import { initDropdown } from "./components/dropdown";
import { faqFn } from "./components/faq";
import { initFeaturesToggle } from "./components/features";
import { initFeaturesToggleSlider } from "./components/features-toggle-slider";
import { headerScroll } from "./components/header-scroll";
import { menuToggle } from "./components/menu";
import { filterPricingCards } from "./components/pricing";
import { initScrollToSection } from "./components/scrollToSection";
import {
  partnersSlider,
  relatedPostsSlider,
  TeamSlider,
} from "./components/sliders";
import { initCustomSelect } from "./components/custom-select";
import { tableOfContents } from "./components/tableOfContents";
import { initVideos } from "./components/video-lazy-load";
import { initCopyToClipboard } from "./components/copyToClipboard";
import { downloadsAccordionFn } from "./components/downloads-accordion";
import { subMenu } from "./components/submenu";
import { initDeliveryMethod } from "./components/deliveryMethod";
import "./components/c-popup";
document.addEventListener("DOMContentLoaded", () => {
  const isHomePage = document.querySelector(".home");
  const isPricingPage = document.querySelector(".page-template-pricing");
  const isBlogPage = document.querySelector(".blog");
  const isArticle = document.querySelector("body.single-post");
  const isSingleEvent = document.querySelector("body.single-wydarzenia");
  const isFoundationPage = document.querySelector(
    "body.page-template-foundation",
  );

  menuToggle();
  // initDropdown();
  headerScroll();
  subMenu();
  initVideos();
  initCopyToClipboard();
  initFeaturesToggleSlider();
  if (isHomePage) {
    partnersSlider();
  }
  if (isSingleEvent) {
    partnersSlider();
  }
  if (isPricingPage) {
    filterPricingCards();
  }
  if (isArticle) {
    tableOfContents();
    relatedPostsSlider();
  }
  if (isFoundationPage) {
    downloadsAccordionFn();
  }
  TeamSlider();
  faqFn();
  initCustomSelect();
  initScrollToSection();
  initDeliveryMethod();

  false;
});
